<script>
  import { createEventDispatcher, onDestroy } from "svelte";
  import { login, lostPassword, userLogin, lastWedding } from "../user.js";
  import { showSignUp } from "../event.js";
  import { Email, validateEmail, Password, Digit } from "./widget";
  import { navigate } from "../router";

  const dispatch = createEventDispatcher();
  const close = async () => dispatch("close");

  let modal;
  let email = null;
  let password = null;
  let c1 = null;
  let c2 = null;
  let c3 = null;
  let c4 = null;
  let c5 = null;
  let c6 = null;
  let code;
  let digit_c1;

  let current = "";

  let showDone = false;
  let recoverPassword = false;
  let validatePassword = false;

  let showInfo = false;
  let infoMessage = null;
  let showError = false;
  let errorMessage = null;

  userLogin.subscribe((value) => {
    console.log(value);
    email = value;
  });

  const reset = () => {
    showError = false;
    errorMessage = null;
    showInfo = false;
    infoMessage = null;
  };

  const onError = (e) => {
    showError = true;
    if (e.toString() == "Error: 401 - 22 Auth failed.") {
      errorMessage = "nom utilisateur ou mot de passe incorrect.";
    } else {
      errorMessage = `Une erreur s'est produite: ${e}.`;
    }
  };

  function goToLostPassword() {
    reset();
    password = null;
    recoverPassword = true;
  }

  const handleSubmit = async () => {
    reset();
    try {
      if (recoverPassword) {
        await lostPassword(email, "send");
        recoverPassword = false;
        validatePassword = true;
      } else if (validatePassword) {
        code = "" + c1 + c2 + c3 + c4 + c5 + c6;
        await lostPassword(email, "verify", code, password);
        recoverPassword = false;
        validatePassword = false;
        showDone = true;
      } else if (showDone) {
        showDone = false;
      } else {
        let r = await login(email, password);
        let user = r.data;
        console.log(user);
        if (user.verified === "1") {
          navigate(`#/select/${$lastWedding}`);
        } else {
          //navigate(`#/?${new Date().getTime()}`, true);
          // force reload
          window.location.reload(true);
        }
        close();
      }
    } catch (e) {
      onError(e);
    }
  };

  function focusNext() {
    const nodes = modal.querySelectorAll("*");
    const tabbable = Array.from(nodes).filter((n) => n.tabIndex >= 0);

    let index = tabbable.indexOf(document.activeElement);
    index += 1;
    if (index < tabbable.length) {
      tabbable[index].focus();
    }
  }

  const handle_keydown = (e) => {
    if (e.key === "Escape") {
      close();
      return;
    }

    if (e.key === "Tab") {
      // trap focus
      const nodes = modal.querySelectorAll("*");
      const tabbable = Array.from(nodes).filter((n) => n.tabIndex >= 0);

      let index = tabbable.indexOf(document.activeElement);
      if (index === -1 && e.shiftKey) index = 0;

      index += tabbable.length + (e.shiftKey ? -1 : 1);
      index %= tabbable.length;

      tabbable[index].focus();
      e.preventDefault();
    }
  };

  const previously_focused = typeof document !== "undefined" && document.activeElement;

  if (previously_focused) {
    onDestroy(() => {
      previously_focused.focus();
    });
  }

  function validateForm(event) {
    switch (event.target.name) {
      case "email":
        validateEmail(event.target);
        break;
      case "c1":
      case "c2":
      case "c3":
      case "c4":
      case "c5":
      case "c6":
        if (
          event.target.value === "" ||
          event.target.value === null ||
          event.target.value === undefined
        ) {
          event.target.setCustomValidity("Un chiffre est requis.");
        } else {
          event.target.setCustomValidity("");
          focusNext();
        }
        break;
      default:
        break;
    }
  }
</script>

<svelte:window on:keydown={handle_keydown} />
<div class="modal-background">
  <div
    class="modal"
    role="dialog"
    aria-modal="true"
    bind:this={modal}
    on:click={(e) => e.stopPropagation()}>
    <button class="close-icon" on:click={close}>x</button>
    <img src="images/logo_titre.svg" height="50px" alt="logo" />
    {#if showError}
      <div class="error">{errorMessage}</div>
    {/if}
    {#if showInfo}
      <div class="info">{infoMessage}</div>
    {/if}
    <form
      on:submit|preventDefault={handleSubmit}
      on:invalid={validateForm}
      on:changed={validateForm}
      on:input={validateForm}>
      {#if showDone}
        <div>
          <h3>Félicitations!</h3>
          <p>
            Votre mot de passe a été changé.
            <br />
            Vous pouvez dès maintenant vous connecter en utilisant le nouveau mot de passe.
          </p>
        </div>
        <button class="submit" type="submit">OK</button>
      {:else if recoverPassword}
        <div>
          <p>Récupérer votre mot de passe</p>
        </div>
        <Email id={"email"} required bind:value={email} bind:current />
        <button class="submit" type="submit">Récupérer</button>
      {:else if validatePassword}
        <p>
          Un code de vérification vous a été envoyé à l'email
          <b>{email}</b>
          .
        </p>
        <p>Saisisez votre nouveau mot de passe</p>
        <Password id={"password"} bind:value={password} bind:current />
        <p>Entrez le code pour continuer.</p>
        <div class="code">
          <Digit id={"c1"} focused bind:value={c1} bind:current />
          <Digit id={"c2"} bind:value={c2} bind:current />
          <Digit id={"c3"} bind:value={c3} bind:current />
          <Digit id={"c4"} bind:value={c4} bind:current />
          <Digit id={"c5"} bind:value={c5} bind:current />
          <Digit id={"c6"} bind:value={c6} bind:current />
        </div>
        <!-- Submit-->
        <button class="submit" type="submit">Valider mon mot de passe</button>
      {:else}
        <Email id={"email"} required bind:value={email} bind:current />
        <Password id={"password"} bind:value={password} bind:current />
        <div class="lost-password">
          <button type="button" on:click={goToLostPassword} class="hyperlink">
            Mot de passe oublié
          </button>
        </div>
        <button class="submit" type="submit">Se connecter</button>
      {/if}
      <div class="go-to-registration">
        Je n'ai pas de compte,
        <button
          type="button"
          on:click={() => close().then(() => showSignUp.set(true))}
          class="hyperlink">
          m'inscrire
        </button>
      </div>
    </form>
  </div>
</div>

<style>
  .modal-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    z-index: 99;
  }

  .modal {
    position: absolute;
    left: 50%;
    top: 50%;
    width: calc(100vw - 4em);
    max-width: 32em;
    max-height: calc(100vh - 4em);
    overflow: auto;
    transform: translate(-50%, -50%);
    padding: 1em;
    border-radius: 0.2em;
    background: white;
    z-index: 100;
  }

  @media screen and (max-width: 600px) {
    .modal {
      width: 100%;
    }
  }

  div.error {
    color: var(--secondary-color);
    background-color: #fff;
    display: block;
    font-size: 12px;
    margin: 3px 0 5px;
    padding: 0;
  }

  form {
    text-align: left;
    padding: 1em;
  }

  button.hyperlink {
    cursor: pointer;
    background: none;
    color: var(--primary-light-color);
    font-size: 18px;
    border: 0;
    border-radius: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    margin: 0;
    padding: 0;
    text-align: left;
  }

  div.go-to-registration {
    font-size: small;
    text-align: center;
  }

  div.go-to-registration button.hyperlink {
    display: inline-block;
    font-size: inherit;
    color: var(--primary-light-color);
    cursor: pointer;
    text-decoration: underline;
  }

  div.lost-password button.hyperlink {
    cursor: pointer;
    background: none;
    color: var(--primary-light-color);
    font-size: small;
    border: 0;
    border-radius: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    margin-top: -10px;
    margin-bottom: 15px;
    padding: 0;
    text-align: left;
  }

  button {
    display: block;
  }

  button:not(:disabled):active {
    background-color: #efefef;
  }

  button.close-icon {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 9999;
    width: 25px;
    color: #666;
    font-size: 24px;
    line-height: 1;
    outline: 0;
    cursor: pointer;
    text-align: center;
    font-family: Arial, sans-serif;
    background: #fff;
    border: none;
    padding: 0;
  }

  :global(button.submit:hover) {
    background-color: var(--primary-light-color);
  }

  :global(button.submit) {
    cursor: pointer;
    border-radius: 5px;
    padding: 0.5rem;
    -webkit-transition: background-color 0.1s linear;
    -o-transition: background-color 0.1s linear;
    transition: background-color 0.1s linear;

    color: #fff;
    height: 40px;
    background-color: var(--primary-color);
    font-size: 14px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    cursor: pointer;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    text-align: center;
    text-decoration: none;
    width: 100%;
  }

  .code {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 15px auto;
    max-width: 350px;
  }

  h3 {
    text-align: center;
  }

  p {
    text-align: center;
    font-size: small;
  }
</style>
